import React, {useCallback, useEffect, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import {useIntl} from 'react-intl'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {KTSVG} from '../../../helpers'
import {getFilePath} from '../../../../helpers/file-helpers'

export function DropzoneInput({
  label,
  setFile,
  value,
  required = false,
  isMulti = false,
  setDeletedFile,
}: DropzoneInputProps) {
  const intl = useIntl()
  const [previewUrl, setPreviewUrl] = useState<string | undefined>()
  const [previewDetailsMultiple, setPreviewDetailsMultiple] = useState<
    File[] | {url: string; name: string}[]
  >([])
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      acceptedFiles.forEach((f) => {
        console.log('file: ', f)
      })
      if (isMulti) setFile([...value, ...acceptedFiles])
      else {
        const file = acceptedFiles[0]
        setFile(file)
      }
    },
    [isMulti, value]
  )

  useEffect(() => {
    if (value && typeof value === 'string') {
      setPreviewUrl(getFilePath(value))
    } else if (value && Array.isArray(value)) {
      const preview: any = []
      value.forEach((element) => {
        if (element.fileName) {
          preview.push({...element, name: element.fileName})
        } else {
          preview.push(element)
        }
      })
      setPreviewDetailsMultiple(preview)
    } else if (value) {
      const url = URL.createObjectURL(value)
      setPreviewUrl(url)
    } else {
      setPreviewUrl(undefined)
      setPreviewDetailsMultiple([])
    }
  }, [value])

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    multiple: isMulti ? true : false,
    maxFiles: isMulti ? 10 : 1,
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
    },
  })

  return (
    <>
      {label && <label className={`pb-1 fw-bold ${required ? 'required' : ''}`}>{label}</label>}
      {previewDetailsMultiple &&
        previewDetailsMultiple.length &&
        previewDetailsMultiple.map((element, index) => (
          <div
            className='d-flex justify-items-center justify-content-between pb-2 border-bottom border-1'
            key={index}
          >
            <a key={index}>{element.name}</a>
            <a
              className='text-danger cursor-pointer'
              onClick={() => {
                if (!(element instanceof File) && setDeletedFile) setDeletedFile(element)
                setFile(value.filter((f: any, i: number) => i !== index))
              }}
            >
              <b>X</b>
            </a>
          </div>
        ))}
      {previewUrl ? (
        <div className='my-2 mx-auto mw-300px min-200px position-relative'>
          <img className='img-fluid ' src={previewUrl} alt='car-image' />
          <a
            className='btn btn-primary'
            onClick={() => {
              setFile(null)
            }}
          >
            temp delete
          </a>
        </div>
      ) : (
        <>
          <div className='_cursor-pointer' {...getRootProps()}>
            <input {...getInputProps()} />
            {
              <div className='card card-body border border-primary border-dotted'>
                <p className='h6 d-flex justify-content-center align-items-center h-50px'>
                  {intl.formatMessage({id: 'INPUT.DROP.FILE'})}
                </p>
              </div>
            }
          </div>
        </>
      )}
    </>
  )
}

interface DropzoneInputProps {
  label: string | React.ReactNode
  setFile: (file: File | File[] | null) => void
  setDeletedFile?: (file: any) => void
  value?: any
  required?: boolean
  isMulti?: boolean
}
